import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { buildUserFromToken, storeAuthFromToken } from "../utils/auth";

export default function SsoLoginPage({ onAuth }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const coreUrl =
    process.env.REACT_APP_CORE_IDENTITY_URL ||
    "https://masterdashboard.xpresspaper.eu";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${coreUrl}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, appKey: "contract-intelligence" }),
      });
      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || "Login failed");
      }
      const data = await res.json();
      const requiresReset =
        data.requiresPasswordReset || data.requires_password_reset;
      const token = data.token;
      if (!token) {
        throw new Error("Missing token");
      }
      if (requiresReset) {
        localStorage.setItem("resetToken", token);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/force-reset", { replace: true });
        return;
      }
      const tokenUser = storeAuthFromToken(token) || buildUserFromToken(token);
      const mergedUser = {
        ...(tokenUser || {}),
        name: data.user?.name || tokenUser?.name,
        email: data.user?.email || tokenUser?.email,
        role: (data.user?.role || tokenUser?.role || "UNKNOWN").toUpperCase(),
        companyId: data.user?.company_id || tokenUser?.companyId || null,
        departmentId: data.user?.department_id || tokenUser?.departmentId || null,
      };
      localStorage.setItem("user", JSON.stringify(mergedUser));
      if (onAuth) onAuth(mergedUser);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bgLight">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-8 w-full max-w-md space-y-4">
        <h1 className="text-2xl font-bold text-navy text-center">
          Login to Contract Intelligence
        </h1>
        {error && (
          <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-slate-800 mb-1">
              Email
            </label>
            <input
              type="email"
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gold/70 focus:border-gold/70"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-800 mb-1">
              Password
            </label>
            <input
              type="password"
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gold/70 focus:border-gold/70"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center px-4 py-2 rounded-lg bg-navy text-white text-sm font-semibold shadow-sm hover:bg-navy/90 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
